"use strict";

(function () {
    var _wp = wp,
        _wp$serverSideRender = _wp.serverSideRender,
        createElement = wp.element.createElement,
        ServerSideRender = _wp$serverSideRender === void 0 ? wp.components.ServerSideRender : _wp$serverSideRender,
        _ref = wp.blockEditor || wp.editor,
        InspectorControls = _ref.InspectorControls,
        useBlockProps = _ref.useBlockProps,
        _wp$components = wp.components,
        TextareaControl = _wp$components.TextareaControl,
        Button = _wp$components.Button,
        PanelBody = _wp$components.PanelBody,
        Placeholder = _wp$components.Placeholder,
        registerBlockType = wp.blocks.registerBlockType;

    // Locate the WP 7.0 block editor canvas iframe. Returns null if the
    // iframe doesn't exist yet or its contentDocument isn't reachable.
    function getEditorIframe() {
        var selectors = [
            'iframe[name="editor-canvas"]',
            'iframe.edit-post-visual-editor__content-area',
            'iframe.editor-canvas'
        ];
        for (var i = 0; i < selectors.length; i++) {
            var el = document.querySelector(selectors[i]);
            if (el && el.contentDocument && el.contentDocument.head) {
                return el;
            }
        }
        return null;
    }

    // Inject sb-youtube.js (and its config + jQuery if needed) into the
    // editor iframe's <head>, so window.sby_init exists inside the iframe
    // and can find the feed DOM that ServerSideRender mounts there.
    // Returns a promise that resolves once the feed init script has loaded.
    var iframeAssetsPromise = null;
    function ensureIframeFeedAssets() {
        if (iframeAssetsPromise) {
            return iframeAssetsPromise;
        }
        iframeAssetsPromise = new Promise(function (resolve, reject) {
            var attempts = 0;
            var tryInject = function () {
                attempts++;
                var iframe = getEditorIframe();
                if (!iframe) {
                    if (attempts > 40) { // ~10s
                        reject(new Error('sby: editor iframe not found'));
                        return;
                    }
                    setTimeout(tryInject, 250);
                    return;
                }
                var doc = iframe.contentDocument;
                if (doc.documentElement.getAttribute('data-sby-feed-assets-injected')) {
                    resolve(iframe);
                    return;
                }
                doc.documentElement.setAttribute('data-sby-feed-assets-injected', '1');

                var config = doc.createElement('script');
                config.textContent =
                    'window.sbyOptions = ' + JSON.stringify(sby_block_editor.sbyOptions || {}) + ';';
                doc.head.appendChild(config);

                var loadScript = function (src) {
                    return new Promise(function (res, rej) {
                        var s = doc.createElement('script');
                        s.src = src;
                        s.onload = function () { res(); };
                        s.onerror = function () { rej(new Error('sby: failed to load ' + src)); };
                        doc.head.appendChild(s);
                    });
                };

                var chain = Promise.resolve();
                if (!iframe.contentWindow.jQuery && sby_block_editor.jqueryUrl) {
                    chain = chain.then(function () { return loadScript(sby_block_editor.jqueryUrl); });
                }
                if (sby_block_editor.iframeScriptUrl) {
                    chain = chain.then(function () { return loadScript(sby_block_editor.iframeScriptUrl); });
                }
                chain.then(function () { resolve(iframe); }, reject);
            };
            tryInject();
        });
        return iframeAssetsPromise;
    }

    // Call sby_init() inside the iframe (WP 7.0+) or in the outer scope as a
    // fallback for pre-iframe editors. Idempotent — safe to call multiple times.
    function triggerSbyInit() {
        var iframe = getEditorIframe();
        if (iframe && iframe.contentWindow && typeof iframe.contentWindow.sby_init === 'function') {
            try { iframe.contentWindow.sby_init(); } catch (e) {}
            return;
        }
        if (!iframe && typeof sby_init !== 'undefined') {
            // Pre-iframe editor — sby-scripts is enqueued on the outer page.
            try { sby_init(); } catch (e) {}
        }
    }

    var sbyIcon = createElement('svg', {
        width: 20,
        height: 20,
        viewBox: '0 0 576 512',
        className: 'dashicon'
    }, createElement('path', {
        fill: 'currentColor',
        d: 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z'
    }));

    registerBlockType('sby/sby-feed-block', {
        apiVersion: 3,
        title: 'Feeds for YouTube',
        icon: sbyIcon,
        category: 'widgets',
        attributes: {
            noNewChanges: {
                type: 'boolean',
            },
            shortcodeSettings: {
                type: 'string',
            },
            executed: {
                type: 'boolean'
            }
        },
        edit: function edit(props) {
            var blockProps = typeof useBlockProps === 'function' ? useBlockProps() : {};
            var _props = props,
                setAttributes = _props.setAttributes,
                _props$attributes = _props.attributes,
                _props$attributes$sho = _props$attributes.shortcodeSettings,
                shortcodeSettings = _props$attributes$sho === void 0 ? sby_block_editor.shortcodeSettings : _props$attributes$sho,
                _props$attributes$cli = _props$attributes.noNewChanges,
                noNewChanges = _props$attributes$cli === void 0 ? true : _props$attributes$cli,
                _props$attributes$exe = _props$attributes.executed,
                executed = _props$attributes$exe === void 0 ? false : _props$attributes$exe;

          props.attributes.shortcodeSettings = shortcodeSettings;

            function setState(shortcodeSettingsContent) {
                setAttributes({
                    noNewChanges: false,
                    shortcodeSettings: shortcodeSettingsContent
                });
            }

            function previewClick(content) {
                setAttributes({
                    noNewChanges: true,
                    executed: false,
                });
            }
            function afterRender() {
                // Inject sb-youtube into the WP 7.0 iframe (no-op once injected),
                // then poll-trigger sby_init in iframe scope. ServerSideRender
                // doesn't expose an onload callback, so we retry on intervals
                // mirroring the previous behavior.
                ensureIframeFeedAssets().catch(function () {});
                setTimeout(triggerSbyInit, 1000);
                setTimeout(triggerSbyInit, 2000);
                setTimeout(triggerSbyInit, 3000);
                setTimeout(triggerSbyInit, 5000);
                setTimeout(triggerSbyInit, 10000);
                setAttributes({
                    executed: true,
                });
            }

            var jsx = [React.createElement(InspectorControls, {
                key: "sby-gutenberg-setting-selector-inspector-controls"
            }, React.createElement(PanelBody, {
                title: sby_block_editor.i18n.addSettings
            }, React.createElement(TextareaControl, {
                key: "sby-gutenberg-settings",
                className: "sby-gutenberg-settings",
                label: sby_block_editor.i18n.shortcodeSettings,
                help: sby_block_editor.i18n.example + ": feed=\"1\"",
                value: shortcodeSettings,
                onChange: setState
            }), React.createElement(Button, {
                key: "sby-gutenberg-preview",
                className: "sby-gutenberg-preview",
                onClick: previewClick,
                isDefault: true
            }, sby_block_editor.i18n.preview)))];

            if (noNewChanges) {
                afterRender();
                jsx.push(React.createElement(ServerSideRender, {
                    key: "feeds-for-youtube/feeds-for-youtube",
                    block: "sby/sby-feed-block",
                    attributes: props.attributes,
                }));
            } else {
                props.attributes.noNewChanges = false;
                jsx.push(React.createElement(Placeholder, {
                    key: "sby-gutenberg-setting-selector-select-wrap",
                    className: "sby-gutenberg-setting-selector-select-wrap"
                }, React.createElement(Button, {
                    key: "sby-gutenberg-preview",
                    className: "sby-gutenberg-preview",
                    onClick: previewClick,
                    isDefault: true
                }, sby_block_editor.i18n.preview)));
            }

            return createElement('div', blockProps, jsx);
        },
        save: function save() {
            return null;
        }
    });
})();
